// Analytics for the public marketing site. Unlike the tenant app (which gates
// PostHog behind a per-tenant analyticsOptIn flag), the marketing site is
// anonymous: no identification, no session recording, and Do Not Track is
// honored. A dedicated marketing PostHog project can be configured via
// NEXT_PUBLIC_MARKETING_POSTHOG_KEY; otherwise the app-wide key is reused.

export interface MarketingAnalyticsConfig {
  enabled: boolean;
  key: string;
  host: string;
}

export interface MarketingAnalyticsEnv {
  marketingKey?: string;
  appKey?: string;
  host?: string;
  doNotTrack?: boolean;
}

export function buildMarketingAnalyticsConfig(env: MarketingAnalyticsEnv): MarketingAnalyticsConfig {
  const key = env.marketingKey || env.appKey || "";
  const host = env.host ?? "";
  const enabled = Boolean(key && host && !env.doNotTrack);
  return { enabled, key, host };
}

// Event names form the marketing funnel contract shared by the site, PostHog
// dashboards, and the n8n performance digest. Rename only with a migration.
export const marketingEvents = {
  pageView: "$pageview",
  bookDemoClick: "marketing_book_demo_click",
  productLoginClick: "marketing_product_login_click",
  scrollDepth: "marketing_scroll_depth",
  faqExpand: "marketing_faq_expand",
} as const;

export const scrollDepthMilestones = [25, 50, 75, 100] as const;

const attributionKeys = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
  "msclkid",
  "ref",
] as const;

export function extractAttribution(search: string): Record<string, string> {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const attribution: Record<string, string> = {};
  for (const key of attributionKeys) {
    const value = params.get(key);
    if (value) {
      attribution[key] = value;
    }
  }
  return attribution;
}
